// extracted by mini-css-extract-plugin
module.exports = {"link":"postPreview-module--link--3TVvm","content":"postPreview-module--content--2tugU","img":"postPreview-module--img--2rfgR"};